import { render, staticRenderFns } from "./cityHold.vue?vue&type=template&id=190144f0&scoped=true&"
import script from "./cityHold.vue?vue&type=script&lang=js&"
export * from "./cityHold.vue?vue&type=script&lang=js&"
import style0 from "./cityHold.vue?vue&type=style&index=0&id=190144f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190144f0",
  null
  
)

export default component.exports